import { faPlay } from '@fortawesome/pro-regular-svg-icons/faPlay';
import { faBracketsCurly } from '@fortawesome/pro-regular-svg-icons/faBracketsCurly';
import { faBolt } from '@fortawesome/pro-regular-svg-icons/faBolt';
import { faSplit } from '@fortawesome/pro-regular-svg-icons/faSplit';
import { faBullseye } from '@fortawesome/pro-regular-svg-icons/faBullseye';
import { faHexagonNodes } from '@fortawesome/pro-regular-svg-icons';
import { faArrowsRepeat } from '@fortawesome/pro-regular-svg-icons/faArrowsRepeat';
import { faClock } from '@fortawesome/pro-regular-svg-icons/faClock';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import {
  IconAnimation,
  IconRotation,
  SemanticCategory,
  IconLabel,
} from '../types';

export const SEMANTIC_CATEGORY: SemanticCategory = 'badge';
export type SemanticCategoryName = typeof SEMANTIC_CATEGORY;

export const icons = {
  'agentic-workflow-trigger': faPlay,
  'agentic-workflow-variable': faBracketsCurly,
  'agentic-workflow-action': faBolt,
  'agentic-workflow-condition': faSplit,
  'agentic-workflow-goal': faBullseye,
  'agentic-workflow-agent': faHexagonNodes,
  'agentic-workflow-loop': faArrowsRepeat,
  'agentic-workflow-branch': faSplit,
  'agentic-workflow-delay': faClock,
  'agentic-workflow-error': faTriangleExclamation,
};

export const labels: IconLabel = {
  'agentic-workflow-trigger': {
    title: (t) => '',
    description: (t) => t('Trigger'),
  },
  'agentic-workflow-variable': {
    title: (t) => '',
    description: (t) => t('Initialize Variable'),
  },
  'agentic-workflow-action': {
    title: (t) => '',
    description: (t) => t('Action'),
  },
  'agentic-workflow-condition': {
    title: (t) => '',
    description: (t) => t('Condition'),
  },
  'agentic-workflow-goal': {
    title: (t) => '',
    description: (t) => t('Goal'),
  },
  'agentic-workflow-agent': {
    title: (t) => '',
    description: (t) => t('AI Agent'),
  },
  'agentic-workflow-loop': {
    title: (t) => '',
    description: (t) => t('Loop'),
  },
  'agentic-workflow-branch': {
    title: (t) => '',
    description: (t) => t('Split Branches'),
  },
  'agentic-workflow-delay': {
    title: (t) => '',
    description: (t) => t('Delay'),
  },
  'agentic-workflow-error': {
    title: (t) => '',
    description: (t) => t('Error'),
  },
};

export type ValidIcons = keyof typeof icons;

export const rotation: IconRotation = {};

export const animation: IconAnimation = {};
